import type { GetExploreContent200PageAllOfSort } from './getExploreContent200PageAllOfSort';

/**
 * Spring Data Page 객체 형태의 페이징 정보
 */
export type GetExploreContent200PageAllOf = {
  /** 내용 없음 여부 */
  empty?: boolean;
  /** 첫 페이지 여부 */
  first?: boolean;
  /** 마지막 페이지 여부 */
  last?: boolean;
  /** 현재 페이지 번호 (pageNumber와 동일) */
  number?: number;
  /** 현재 페이지의 요소 수 */
  numberOfElements?: number;
  /** 현재 페이지의 시작 오프셋 */
  offset?: number;
  /** 페이징 여부 */
  paged?: boolean;
  /** 현재 페이지 번호 (0부터 시작) */
  pageNumber?: number;
  /** 페이지 크기 */
  pageSize?: number;
  /** 페이지 크기 (pageSize와 동일) */
  size?: number;
  /** 정렬 정보 */
  sort?: GetExploreContent200PageAllOfSort;
  /** 전체 요소 수 */
  totalElements?: number;
  /** 전체 페이지 수 */
  totalPages?: number;
  /** 페이징 안함 여부 */
  unpaged?: boolean;
};
